import type { TFunction } from 'i18next';
import { formatFrequency } from '@/lib/formatFrequency';

/**
 * A manual capacity value as one line of prose: "Einmal pro Woche · 15 min".
 * Read by the capacity section (a draft step without a live recording has no
 * hours to show) and by the conflict dialog.
 */
export function manualCapacityLabel(
  value: { frequency: string; frequencyTimesPerPeriod?: number; durationMinutes: number },
  t: TFunction
): string {
  return t('processDraft.capacity.primitives', {
    frequency: formatFrequency(value.frequency, value.frequencyTimesPerPeriod, t),
    minutes: value.durationMinutes
  });
}
